import { useNavigate, useLocation } from "react-router-dom";
import TabelaAuditoriaSistema from "./TabelaAuditoriaSistema";
import TabelaModificacoesSistema from "./TabelaModificacoesSistema";

export default function Index() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const openTable = params.get("secao");

  const handleToggle = (table: "acessos" | "modificacoes") => {
    const search = new URLSearchParams();
    const municipio = params.get("municipio");
    if (municipio) search.set("municipio", municipio);
    if (openTable !== table) search.set("secao", table);
    navigate({ pathname: location.pathname, search: search.toString() }, { replace: true });
  };

  return (
    <div>
      <TabelaAuditoriaSistema isOpen={openTable === "acessos"} onToggle={() => handleToggle("acessos")} />
      <TabelaModificacoesSistema isOpen={openTable === "modificacoes"} onToggle={() => handleToggle("modificacoes")} />
    </div>
  );
}
